function statsSlider() {
  const statsSlider = new Swiper('.js-stats-slider', {
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
}


export { statsSlider };